<template>
  <section
    class="external-wordcloud-section"
    :style="{
      '--wordcloud-panelBgColor': config.panelBgColor,
      '--wordcloud-outlineColor': config.panelOutlineColor,
      '--wordcloud-questionColor': config.questionColor,
      '--wordcloud-questionBgColor': config.questionBgColor,
      '--wordcloud-optionsColor': config.optionsColor,
      '--wordcloud-optionsBgColor': config.optionsBgColor,
      '--wordcloud-pickedColor': config.pickedColor,
      '--wordcloud-pickedBgColor': config.pickedBgColor,
      '--wordcloud-btnColor': config.btnColor,
      '--wordcloud-btnBgColor': config.btnBgColor,
      '--wordcloud-correctColor': config.correctColor,
      '--wordcloud-correctBgColor': config.correctBgColor,
      '--wordcloud-incorrectColor': config.incorrectColor,
      '--wordcloud-incorrectBgColor': config.incorrectBgColor,
    }">
    <div class="question-container">
      <div class="question-img-container">
        <img class="question-img" :src="data.raw_data.question.image" v-if="data.raw_data.question.image" />
        <div class="question-text" v-if="data.raw_data.question" v-html="data.raw_data.question"></div>
      </div>
      <input ref="input" type="text" class="input-word" spellcheck="false" placeholder="Digite aqui..." @keypress="checkSend" v-model="promptInput" v-show="!finished && !isBusy" />
      <button class="word-send-button" @click.prevent="sendWord" @touchstart="sendWord" v-show="!showResult && promptInput && !isBusy">{{ sendText }}</button>
      <SpinnerButton class="btn-alt" style="background: none; min-width: 40px; padding: 10px; margin: 0 auto; z-index: 1" v-if="isBusy" />

      <span class="wordcloud-thanks">
        <p style="margin: 10px 0" v-html="postSendText" v-show="!typeShowResults && finished && !promptInput"></p>
        <iframe :id="currentIframeId" :src="iframeSrc" frameborder="0" v-if="iframeSrc && showResult"></iframe>
      </span>
    </div>
  </section>
</template>

<script>
import api from '@/services/api';
import SpinnerButton from '@/components/ui/SpinnerButton.vue';

export default {
  name: 'WordCloud',

  components: {
    SpinnerButton,
  },

  props: { data: Object, sendText: String, postSendText: String, config: Object, typeShowResults: Boolean },

  data() {
    return {
      wordcloudData: {
        wordcloud_id: '',
        prompt: '',
        multiple: false,
        words: {},
      },
      promptInput: '',
      showResult: false,
      iframeSrc: '',
      finished: false,
      isBusy: false,
    };
  },
  computed: {
    currentIframeId() {
      return 'iframe' + this.data.raw_data.wordcloud_id;
    },
  },
  methods: {
    checkSend(key) {
      // console.log('SCROLLTop: ' + this.$refs.messagesContainer.scrollTop);
      if (key.keyCode == 13) this.sendWord();
    },
    sendWord() {
      if (!this.promptInput.length) return;
      this.isBusy = true;
      api
        .post(`/addWordToCloud/${this.$route.params.stream}/${this.data.interactivity_id}`, {
          userId: this.$store.state.user.id,
          wordcloud_id: this.data.interactivity_id,
          word: this.promptInput,
          activity_id: this.$route.params.stream,
        })
        .then((response) => {
          // console.log('sendWord ', { response });
          if (this.data.raw_data.type.showResults) {
            setTimeout(() => {
              this.showResult = this.data.raw_data.type.showResults;
              this.promptInput = '';
              this.finished = true;
              this.viewWordcloud(this.data.raw_data.wordcloud_id);
              this.isBusy = false;

              api.post(`sessionAction/`, {
                action: 'WordCloud New Word',
                properties: JSON.stringify({ route: this.$route.name, params: this.$route.params }),
                userid: this.$store.state.user.id,
                sessionid: this.$store.state.user.token,
                event_id: this.$store.state.eventId,
              });
            }, 1300);
          }else{
            this.promptInput = '';
            this.finished = true;            
            this.isBusy = false;
          }
        })
        .catch((err) => {
          console.error('error adding word', err);
        });
    },
    onMessage(msg) {
      let winRef = msg.source;
      let data;
      try {
        data = JSON.parse(msg.data);
      } catch (err) {
        return;
      }
      if (data.type == 'get-wordcloud' && this.currentIframeId && document.getElementById(this.currentIframeId)) {
        // console.log('get wordcloud', { msg }, this.data.interactions);

        let words = [];
        if (this.data.interactions)
          this.data.interactions.map((inter) => {
            words.push([inter.answer, inter.interactions]);
          });

        document.getElementById(this.currentIframeId).contentWindow.postMessage(
          JSON.stringify({
            type: 'wordcloud-data',
            data: words,
          }),
          '*'
        );
        winRef.postMessage(
          JSON.stringify({
            type: 'wordcloud-data',
            data: words,
          }),
          '*'
        );
      }
    },
    viewWordcloud(id) {
      // window.open(`//localhost:8000/wordcloud/wordcloud.html#/${ id }`);
      this.iframeSrc = '';
      this.$nextTick(() => {
        this.iframeSrc = `//proto-assets.s3.amazonaws.com/dataviz/wordcloud/wordcloud_test.html#/${id}`;
        // window.open(`//proto-assets.s3.amazonaws.com/dataviz/wordcloud/wordcloud.html#/${id}`);
      });
    },
  },
  mounted() {
    window.addEventListener('message', this.onMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onMessage);
  },
};
</script>

<style scoped lang="scss">
.external-wordcloud-section {
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;

  .question-container {
    position: relative;
    // margin: 0 auto;
    width: 100%;
    max-width: 1024px;
    border-radius: var(--input-borderRadius);
    border: 1px solid var(--wordcloud-outlineColor);
    padding-bottom: 20px;
    text-align: center;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;

    background: var(--wordcloud-panelBgColor);
    @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
      .question-container {
        background: none;
        -webkit-backdrop-filter: blur(40px);
        backdrop-filter: blur(40px);
      }
    }
  }

  .question-img-container {
    padding: 12px 0;
    width: 100%;
    .question-img {
      width: 100%;
      height: auto;
      max-width: 100%;
      max-height: 306px;
      object-fit: contain;
      border-radius: var(--input-borderRadius) var(--input-borderRadius) 0 0;
    }
    .question-text {
      position: relative;
      margin: 0 15px 15px;
      padding: 8px;
      border-radius: var(--input-borderRadius);
      color: var(--wordcloud-questionColor);
      background: var(--wordcloud-questionBgColor);
      font-size: 1.2rem;
      text-align: center;
    }
  }

  .input-word {
    // caret-color: red;
    font-size: 1.2rem;
    letter-spacing: 1px;
    outline: none;
    resize: none;
    padding: 10px;
    height: 120px;
    color: var(--wordcloud-optionsColor);
    outline: none;
    background: #333;
    border: 1px solid #777;
    border-radius: var(--input-borderRadius);
    margin: 10px 0;
    text-align: center;
    background: transparent;

    &::placeholder {
      color: var(--wordcloud-optionsColor);
      opacity: 0.33;
      cursor: auto;
    }

    &:focus {
      outline: 1px solid var(--wordcloud-pickedBgColor);
    }
  }

  .word-send-button {
    position: relative;
    width: 96%;
    padding: 2% 8%;
    margin: 10px 10px 0;
    z-index: 10;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1px;
    color: var(--wordcloud-pickedColor);
    // opacity: 0.9;
    cursor: auto;
    // opacity: 0.8;
    background-color: var(--wordcloud-pickedBgColor);
    // border-radius: var(--input-borderRadius);
    border: none;
    border-top: 2px solid var(--live-bgColor);
    border-radius: var(--input-borderRadius);
    outline: none;
    cursor: pointer;
  }
  .wordcloud-thanks {
    position: relative;
    width: 100%;
    // min-height: 300px;
    height: 100%;
    color: var(--wordcloud-optionsColor);
    opacity: 0.33;
    cursor: auto;
    opacity: 0.8;
    font-weight: bold;
    border-radius: var(--input-borderRadius);
    padding: 0px 30px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    iframe {
      width: 100%;
      height: 100%;
      min-height: 400px;
      // flex-grow: 1;
    }
  }
}
</style>
